<template>
  <div class="mb-3">
    <b-button
      :class="visible ? null : 'collapsed'"
      :aria-expanded="visible ? 'true' : 'false'"
      aria-controls="collapse-4"
      @click="onClick"
      class="btn"
    >
      <span style="display:flex; justify-content:space-between">
        <label
          :for="field.id"
          class="form-label"
          :class="{ 'text-danger': !!field.error }"
          >{{ field.name + (field.required ? '*' : '') }}
        </label>
        <span class="caret-icons">
          <span v-if="visible">
            <font-awesome-icon icon="chevron-up" />
          </span>
          <span v-else>
            <font-awesome-icon icon="chevron-down" />
          </span>
        </span>
      </span>
    </b-button>
  </div>
</template>

<script>
import Card from '../containers/Card.vue';
import Tooltip from '../global/Tooltip.vue';

export default {
  name: 'Toggle',
  data() {
    return {
      visible: true,
    };
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.visible = false;
  },
  methods: {
    onClick($event) {
      this.visible = !this.visible;
      this.$emit('input', this.visible);
    },
  },
  components: {
    Card,
    Tooltip,
  },
};
</script>
<style scoped>
.caret-icons {
  margin-right: 12px;
}
.btn {
  width: 100%;
  padding: 0%;
  margin: 0%;
  background: none;
  border: none;
}
.form-label {
  cursor: pointer;
  font-size: 16px;
  color: #045665;
  text-align: left;
}
.btn:focus,
.btn.focus {
  border: 0;
  box-shadow: none;
}
</style>
